export function clampDate(date: Date, min: Date, max: Date, isStart: boolean): Date {
  if (date < min) return isStart ? new Date(min) : new Date(max);
  if (date > max) return new Date(max);

  return date;
}
